import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';

import { ButtonComponent } from '@shared/components/button';
import {
  PlainTableComponent,
  TableColumn,
} from '@shared/components/plain-table';
import { ESTATE_TABLE_COLUMNS } from './estate-table.constants';
import { EstateTableData } from './estate-table.interface';

@Component({
  selector: 'app-estate-table',
  templateUrl: './estate-table.component.html',
  imports: [PlainTableComponent, ButtonComponent, FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstateTableComponent {
  public data = input.required<EstateTableData[]>();
  public isLoading = input<boolean>(false);
  public columns = input<TableColumn[]>(ESTATE_TABLE_COLUMNS);
  public deleteDisabled = input<boolean>(false);

  public view = output<EstateTableData>();
  public delete = output<EstateTableData>();

  // Icons
  protected readonly faEye = faEye;
  protected readonly faTrash = faTrash;
}
